export default [
  /auto.vehicles.([^.]*).principalOperator/,
  /auto.vehicles.([^.]*).useVinLookup/,
  /auto.vehicles.([^.]*).vin/,
  /auto.vehicles.([^.]*).year/,
  /auto.vehicles.([^.]*).make/,
  /auto.vehicles.([^.]*).model/,
  /auto.vehicles.([^.]*).submodel/,
]
